
<b-modal
  :key="id"
  id="remote"
  size="lg"
  hideFooter
  hideHeader
  hideBackdrop
  noFade
  v-show="show"
  return-focus=".ql-editor"
  @show="showModal"
  @keydown.esc="closeModal"
  @hide="closeModal"
>
  <b-overlay :show="localsession" rounded="sm">
    <template #overlay>
      <div class="text-center">
        <b-icon
          icon="exclamation-circle-fill"
          font-scale="3"
          animation="cylon"
        ></b-icon>
        <p class="lead">Du är redan ansluten till en lokal tolkning</p>
      </div>
    </template>
    <b-overlay :show="qr.show" @click="toggleQRCode" rounded="sm">
      <template #overlay>
        <div class="text-center">
          <qrcode-vue :value="qr.value" :size="400" level="H" />
        </div>
      </template>
      <b-row>
        <b-col>
          <h3>Distanstolkning</h3>
        </b-col>
        <b-col>
          <!--
      <div class="float-right">
        <b-badge v-if="connected === 'online'" variant="success">Du är ansluten till internet</b-badge>
        <b-badge
          v-else-if="connected === 'local'"
          variant="warning"
        >Du är ansluten till ett lokalt nätverk</b-badge>
        <b-badge
          v-else-if="connected === 'offline'"
          variant="danger"
        >Din dator är ej ansluten till ett nätverk/internet</b-badge>
        <span v-else>
          Testar din internetanslutning...
          <b-spinner small label="Loading..." />
        </span>
      </div>
      -->
        </b-col>
      </b-row>
      <b-tabs :tabindex="tabindex">
        <b-tab title="Anslut">
          <b-card>
            <b-card-header>
              <h5>Dina bokade tolkningar</h5>
              <div class="float-right" v-if="inSession">
                <b-badge variant="warning"
                  >Du är ansluten till en distanstolkning.</b-badge
                >
              </div>
            </b-card-header>
            <b-card-body
              style="max-height: 40vh; overflow-y: auto; width: 100%"
            >
              <b-list-group
                size="sm"
                v-for="sess in sessions"
                v-bind:key="sess.id"
              >
                <b-list-group-item v-if="!inSession || sess.id == session.id">
                  <b-row>
                    <b-col>
                      <b>
                        {{ sess.name }}
                      </b>
                      <br />
                      <b-button
                        v-if="ownSession(sess) && !sess.public && !inSession"
                        @click="removeRemoteSession(sess.id)"
                        size="sm"
                        variant="danger"
                        >Ta bort</b-button
                      >
                      <b-button
                        v-if="!ownSession(sess) && !sess.public && !inSession"
                        @click="leaveRemoteSession(sess.id)"
                        size="sm"
                        variant="warning"
                        >Lämna/dölj</b-button
                      >
                      <!--
                                              <b-button
                                                  @click.prevent
                                                  :id="'details' + sess.id"
                                                  variant="info"
                                                  >Visa detaljer</b-button
                                              >
                                              <b-popover
                                                  :target="
                                                      'details' + sess.id
                                                  "
                                                  placement="left"
                                              >
                                                  <template #title
                                                      >Bokningsdetaljer:
                                                      {{ sess.id }}</template
                                                  >
                                                  <b-row>
                                                      <b-col cols="4"
                                                          >Från:</b-col
                                                      >
                                                      <b-col>{{
                                                          sess.from
                                                              | formatDate
                                                      }}</b-col>
                                                  </b-row>
                                                  <b-row>
                                                      <b-col cols="4"
                                                          >Till:</b-col
                                                      >
                                                      <b-col>{{
                                                          sess.to | formatDate
                                                      }}</b-col>
                                                  </b-row>
                                                  <b-row>
                                                      <b-col cols="4"></b-col>
                                                      <b-col>
                                                          <span
                                                              v-if="
                                                                  sess.recurring
                                                              "
                                                              >Återkommande</span
                                                          >
                                                      </b-col>
                                                  </b-row>
                                                  <b-row>
                                                      <b-col cols="4"></b-col>
                                                      <b-col></b-col>
                                                  </b-row>

                                                  <b-row>
                                                      <b-col cols="4"
                                                          >Typ:</b-col
                                                      >
                                                      <b-col>{{
                                                          getSessionType(
                                                              sess.type
                                                          )
                                                      }}</b-col>
                                                  </b-row>

                                                  <b-row>
                                                      <b-col cols="4"
                                                          >Beställare:</b-col
                                                      >
                                                      <b-col>{{
                                                          sess.ref
                                                      }}</b-col>
                                                  </b-row>
                                                  <hr />
                                                  Övrig information:
                                                  <br />
                                                  <span
                                                      v-html="
                                                          sess.description
                                                      "
                                                  />
                                                  <hr />
                                                  <br />
                                                  <br />
                                              </b-popover>
                            -->
                    </b-col>
                    <b-col>
                      <b-button
                        @click="toClipboard('user', sess)"
                        variant="secondary"
                        >Kopiera länk</b-button
                      >
                      <b-button
                        @click="toggleQRCode(sess)"
                        variant="secondary"
                        >Visa QR-kod</b-button
                      >
                      <b-button
                        v-if="!inSession"
                        variant="primary"
                        @click="joinRemoteSession(sess.id)"
                        >Anslut</b-button
                      >
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-card-body>
          </b-card>
          <b-card
            title="Anslut till kollegas distanstolkning"
            sub-title="Skriv in bokningens ID-nummer eller klistra in länken till skrivtolkningen."
          >
            <b-card-text>
              <br />
              <b-form inline class="float-right" @submit.prevent>
                <b-form-input
                  v-model="session.id"
                  autofocus
                  placeholder="Ange sessionens ID-nummer"
                  :disabled="inSession"
                  @keydown.enter="joinRemoteSession(session.id)"
                />
                <b-button
                  v-if="!inSession"
                  variant="primary"
                  @click="joinRemoteSession(session.id)"
                  >Anslut</b-button
                >
                <b-button v-else variant="danger" @click="closeRemoteSession"
                  >Koppla ner</b-button
                >
              </b-form>
            </b-card-text>
          </b-card>
        </b-tab>
        <b-tab title="Skapa">
          <b-card
            title="Skapa distanstolkning"
            sub-title="Låt andra ta del av texten via internet"
          >
            <b-card-text>
              <b-form @submit.prevent="createRemoteSession">
                <div v-show="inSession == false">
                  <b-button type="submit">Skapa</b-button>
                </div>
              </b-form>
              <div v-show="inSession == true">
                <b-card
                  title="Sessionsuppgifter"
                  sub-title="Dessa uppgifter delar du med dig om du vill låta användare eller kollegor ansluta till din tolkning"
                >
                  <b-card-text>
                    <b-form>
                      <b-row>
                        <b-col cols="3"> Tolkanvändarvy </b-col>
                        <b-col>
                          <b-form-input
                            readonly
                            :value="
                              'https://sttylus.se/visa/#/' +
                              session.id +
                              '/' +
                              session.password
                            "
                            @click="toClipboard('view', session)"
                          />
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="3"> Sessions-ID </b-col>
                        <b-col>
                          <b-form-input
                            readonly
                            :value="session.id"
                            @click="toClipboard('id', session)"
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="3">Lösenord</b-col>
                        <b-col>
                          <b-form inline @submit.prevent="setSessionPassword">
                            <b-form-input
                              placeholder="Välj ett lösenord..."
                              v-model="session.password"
                            />
                            <b-button
                              v-if="passwordChanged"
                              @click="setSessionPassword"
                              >Ändra</b-button
                            >
                          </b-form>
                        </b-col>
                      </b-row>
                      <!--<b-form-input
                                                  :value="
                                                          'http://localhost:3345/#/' + session.id + '/' + session.password
                                                  "
                                              />#
                                              -->
                    </b-form>
                  </b-card-text>
                </b-card>
                <br />
                <b-button @click="closeRemoteSession"
                  >Koppla ner från session</b-button
                >
              </div>
            </b-card-text>
          </b-card>
          <b-card
            v-show="inSession == true"
            title="Skrivtolka till andra plattformar"
            subTitle="Välj att få skrivtolkningen som closed captions till t.ex. videomöten eller livestreams."
          >
            <b-card-text>
              <b-form @submit.prevent="bindAPIToken">
                <b-row>
                  <b-col cols="3">
                    <b-form-select
                      v-model="thirdpartyservice"
                      :options="thirdpartyOptions"
                    />
                  </b-col>
                  <b-col cols="6" v-if="thirdpartyservice == 'captions'">
                    <b-form-input
                      :value="'https://sttylus.se/text/' + session.id"
                      @click="toClipboard('captions', session)"
                    />
                    <b-form-input
                      :value="'https://sttylus.se/GETlivecap/' + session.id"
                      @click="toClipboard('glc', session)"
                    />
                  </b-col>
                  <b-col cols="6" v-if="thirdpartyservice == 'zoom'">
                    <b-form-input
                      :disabled="connected3rdparty"
                      placeholder="Mötets API-token"
                      v-model="session.token"
                    />
                  </b-col>
                  <b-col v-if="thirdpartyservice == 'zoom'">
                    <b-button @click="bindAPIToken">Anslut</b-button>
                  </b-col>

                  <b-form
                    v-if="breakout"
                    inline
                    class="float-right"
                    @submit.prevent="bindAPIToken"
                  >
                    <b-form-input
                      :disabled="true"
                      placeholder="Breakout room ej implementerat"
                      v-model="session.breakout"
                    />
                    <br />
                    <b-button
                      v-if="!connectedBreakout"
                      @click="bindBreakoutRoom"
                      >Byt rum</b-button
                    >
                    <b-button
                      v-if="connectedBreakout"
                      @click="leaveBreakoutRoom"
                      >Lämna rum</b-button
                    >
                  </b-form>
                  <div
                    v-if="thirdPartyError && !session.token"
                    class="text-danger float-right"
                  >
                    <small>Felmeddelande: {{ thirdPartyError }}</small>
                  </div>
                </b-row>
              </b-form>
            </b-card-text>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-overlay>
  </b-overlay>
</b-modal>
